import { Genre } from 'types/graphql-api.generated';

import request from 'common/tools/network/request';
import { path } from 'common/tools/network/routing';

const OPES_JS_FILE_PATH = path('rewind_conf_json');

export type SuggestedEntitiesList = {
  release_from?: '2025-01-01';
  release_to?: '2025-12-31';
};

export type RewindConfig = {
  main?: {
    background?: string | null;
    color?: string | null;
    font?: string | null;
    logo?: {
      url?: string | null;
      width?: number | null;
      height?: number | null;
    };
  };
  screens?: Partial<Record<ScreenNames, Screen>>;
  suggested_entities_list?: SuggestedEntitiesList;
  provider?: {
    covers?: string[];
    logo_url?: string;
    cta_link?: string;
  };
};

export type RewindImages = {
  rewind2024Badge?: string;
  rewind2024Bg?: string;
};

type Data = {
  'translations-graph_genres'?: Record<Genre, string>;
  config?: RewindConfig;
  images?: RewindImages;
  translations?: { [key: string]: string | undefined };
};

let data: Omit<Data, 'translations'> | undefined;

const loadOpes = async () => {
  if (!data) {
    const responseData = await request<Data>(OPES_JS_FILE_PATH);

    const { translations, ...opeData } = responseData;
    data = opeData;
    window.AC.translations = {
      ...window.AC.translations,
      ...translations
    };
  }
  return data;
};

export default loadOpes;
